import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { Accordion } from "ui";

import { DetailedWorkoutItemGroup } from "src/components/DetailedWorkoutItemGroup";
import { NormalWorkoutItem } from "src/components/NormalWorkoutItem";
import { DetailedWorkoutItemsList } from "src/workouts/DetailedWorkoutItemsList";
import { DraftWorkoutItemView } from "src/workouts/DraftWorkoutItemView";
import { useWorkoutItemsDragAndDropManager } from "src/workouts/WorkoutItemsDragAndDropManagerContext";
import { useWorkoutItemsInsert } from "src/workouts/WorkoutItemsInsertContext";

export const WorkoutItemsRoot = observer(function WorkoutItemsRoot() {
  const manager = useWorkoutItemsDragAndDropManager();
  const WorkoutItemsInsert = useWorkoutItemsInsert();

  return (
    <Accordion
      className={"flex flex-col gap-2 pb-4"}
      type={"multiple"}
      onValueChange={(ids) => {
        manager.toggleAll(ids);
      }}
      value={toJS(manager.accordionValue)}
    >
      <DetailedWorkoutItemsList
        renderGroup={(args) => {
          return <DetailedWorkoutItemGroup {...args} />;
        }}
        renderNormal={(args) => {
          return <NormalWorkoutItem {...args} />;
        }}
        renderInsert={(args) => {
          return <WorkoutItemsInsert {...args} />;
        }}
        renderDraft={(item, level, index) => {
          return (
            <DraftWorkoutItemView
              key={item.workoutItemId}
              level={level}
              index={index}
              layout={item}
            />
          );
        }}
      />
    </Accordion>
  );
});
